/* Spanish catalog mirroring locale-advisor-reports-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'adv.cf.cashBasisMissing': 'No hay evidencia de caja disponible. Los saldos y los movimientos deben conciliarse con el libro mayor.',
  'adv.cf.cashBalanceEvidence': 'El saldo contabilizado de caja y bancos es {amount}. No es un saldo confirmado por el banco.',
  'adv.rpt.period.profit': 'En el T{quarter} de {year}, los ingresos son {income} y el beneficio es {result}.',
  'adv.rpt.period.loss': 'En el T{quarter} de {year}, los ingresos son {income} y la pérdida es {result}.',
  'adv.rpt.period.nativeSuppliers': 'El ranking de proveedores abarca las compras con fecha del trimestre, excluidos los activos fijos y los resúmenes anuales importados sin fecha.',
  'adv.rpt.period.choose': 'Período',
  'adv.rpt.period.year': 'Año completo',
  'adv.rpt.period.yearLabel': 'Año completo {year}',
  'adv.rpt.period.quarter': 'Trimestre {quarter}',
  'adv.rpt.period.label': 'T{quarter} {year}',
  'adv.rpt.period.vsQuarter': 'frente al mismo trimestre del año pasado',
  'adv.rpt.period.quarterBasis': 'Cifras contables de {from}–{to}. Los importes del balance son al cierre del período.',
  'adv.rpt.period.currentStatus': 'Estado del seguimiento al generarse el {date}. Esta sección usa las partidas abiertas actuales y el resumen anual, no el estado histórico al cierre del trimestre.',
  'adv.rpt.period.rolling': 'Últimos 12 meses hasta {to}, comparados con los 12 meses anteriores.',
  'adv.rpt.period.nativeSales': 'Los detalles de clientes y facturas abarcan las facturas contabilizadas con fecha dentro del trimestre. Aquí se excluyen los resúmenes anuales importados sin desglose trimestral.',
  'adv.rpt.period.budget': 'Los datos reales del trimestre seleccionado se comparan con el presupuesto de esos mismos tres meses.',
  'adv.rpt.period.pdfUnavailable': 'El nuevo diseño de PDF aún no está disponible en el servidor. Inténtalo de nuevo después de la actualización.',
  'adv.rpt.slides.present': 'Presentar',
  'adv.rpt.slides.exit': 'Salir de la presentación',
  'adv.rpt.slides.readable': 'Leer el texto de la página',
  'adv.rpt.slides.previous': 'Anterior',
  'adv.rpt.slides.next': 'Siguiente',
  'adv.rpt.slides.page': 'Página {current} de {total}',
  'adv.rpt.modal.title': 'Crear informe',
  'adv.rpt.modal.intro': 'Elige una plantilla de informe. SuperPlumma toma las cifras de tus cuentas y prepara un borrador que puedes revisar antes de compartirlo.',
  'adv.rpt.modal.generate': 'Generar informe',
  'adv.rpt.modal.cancel': 'Cancelar',
  'adv.rpt.modal.basis': 'Base de datos: {sources}',
  'adv.rpt.modal.year': 'Ejercicio fiscal',
  'adv.rpt.modal.saved': 'Informes guardados',
  'adv.rpt.modal.savedEmpty': 'Todavía no tienes informes guardados.',
  'adv.rpt.modal.open': 'Abrir',
  'adv.rpt.modal.delete': 'Eliminar',
  'adv.rpt.modal.deleted': 'Informe eliminado.',
  'adv.rpt.hero.cta': 'Crear informe',
  'adv.rpt.saved.title': 'Informes guardados',
  'adv.rpt.saved.tab': 'Informes guardados',
  'adv.rpt.saved.description': 'Los informes guardados se conservan como instantáneas y no cambian cuando se actualizan las cuentas.',
  'adv.rpt.saved.count': '{count} de {limit} informes guardados',
  'adv.rpt.saved.limitError': 'Puedes guardar hasta {limit} informes. Elimina un informe antes de guardar uno nuevo.',
  'adv.rpt.saved.loading': 'Cargando informes guardados …',
  'adv.rpt.saved.emptyTitle': 'No hay informes guardados',
  'adv.rpt.saved.emptyText': 'Crea un informe y guárdalo cuando quieras conservar esa versión exacta.',
  'adv.rpt.saved.loadFailed': 'No se pudieron cargar los informes guardados.',
  'adv.rpt.saved.deleteFailed': 'No se pudo eliminar el informe.',
  'adv.rpt.tpl.styre.name': 'Informe para el consejo y la dirección',
  'adv.rpt.tpl.styre.desc': 'Informe completo para el consejo con resultado, liquidez, riesgos y acciones recomendadas.',
  'adv.rpt.tpl.manedsrapport.name': 'Informe mensual',
  'adv.rpt.tpl.manedsrapport.desc': 'Estado del mes seleccionado con presupuesto, comparación con el año anterior, tendencia y próximos pasos recomendados.',
  'adv.rpt.tpl.likviditet.name': 'Informe de liquidez',
  'adv.rpt.tpl.likviditet.desc': 'Partidas abiertas, colchón y saldo acumulado según las cifras contabilizadas.',
  'adv.rpt.tpl.avvik.name': 'Informe de resultado y desviaciones',
  'adv.rpt.tpl.avvik.desc': 'Las mayores desviaciones respecto al presupuesto en lo que va de año y las líneas de costes que más se han movido.',
  'adv.rpt.tpl.kunde.name': 'Informe de clientes y ventas',
  'adv.rpt.tpl.kunde.desc': 'Evolución de las ventas, mayores clientes, concentración de clientes y cuentas por cobrar.',
  'adv.rpt.tpl.kostnad.name': 'Informe de costes',
  'adv.rpt.tpl.kostnad.desc': 'Evolución de los costes, mayores proveedores y compras sin documentación.',
  'adv.rpt.tpl.utestaende.name': 'Partidas abiertas',
  'adv.rpt.tpl.utestaende.desc': 'Partidas pendientes de clientes y proveedores, separadas entre vencidas y aún no vencidas.',
  'adv.rpt.tpl.arsoppsummering.name': 'Resumen del año',
  'adv.rpt.tpl.arsoppsummering.desc': 'Resume todo el año: resultado, balance, ventas, costes y riesgos.',
  'adv.rpt.length.2to3': '2–3 páginas',
  'adv.rpt.length.2to4': '2–4 páginas',
  'adv.rpt.length.3to5': '3–5 páginas',
  'adv.rpt.length.4to6': '4–6 páginas',
  'adv.rpt.length.8to12': '8–12 páginas',
  'adv.rpt.length.variable': 'La extensión depende de los datos disponibles',
  'adv.rpt.length.10to14': '10–14 páginas',
  'adv.rpt.doc.contents': 'Contenido',
  'adv.rpt.doc.brand': 'PLUMME / ASESOR IA',
  'adv.rpt.doc.continued': 'continuación',
  'adv.rpt.doc.back': 'Atrás',
  'adv.rpt.doc.draft': 'Borrador',
  'adv.rpt.doc.saved': 'Guardado',
  'adv.rpt.doc.save': 'Guardar',
  'adv.rpt.doc.savedToast': 'Informe guardado.',
  'adv.rpt.doc.exportPdf': 'Exportar PDF',
  'adv.rpt.doc.exportPptx': 'Descargar PowerPoint',
  'adv.rpt.doc.exportingPptx': 'Creando PowerPoint …',
  'adv.rpt.doc.exportPptxFailed': 'No se pudo crear el archivo de PowerPoint. Inténtalo de nuevo.',
  'adv.rpt.doc.presentation': 'PRESENTACIÓN',
  'adv.rpt.doc.coverFoot': 'Generado a partir de los datos del informe en Plumme',
  'adv.rpt.doc.exporting': 'Creando PDF …',
  'adv.rpt.doc.exportFailed': 'No se pudo crear el archivo del informe. Inténtalo de nuevo.',
  'adv.rpt.doc.period': '{year} · {months} meses del año',
  'adv.rpt.doc.createTask': 'Crear tarea',
  'adv.rpt.doc.taskCreated': 'Añadida al centro de acciones con seguimiento el {date}.',
  'adv.rpt.doc.taskFailed': 'No se pudo crear la tarea.',
  'adv.rpt.doc.taskNote': 'Creada a partir de {report}.',
  'adv.rpt.narr.section': 'Resumen de SuperPlumma',
  'adv.rpt.narr.tag': 'Redactado por SuperPlumma',
  'adv.rpt.narr.idle': 'Deja que SuperPlumma lea el informe y redacte el resumen: qué está en juego, qué se ha movido de verdad y qué hacer ahora.',
  'adv.rpt.narr.write': 'Redactar resumen',
  'adv.rpt.narr.rewrite': 'Reescribir',
  'adv.rpt.narr.loading': 'SuperPlumma está leyendo el informe …',
  'adv.rpt.narr.failed': 'No se pudo redactar el resumen. Las cifras del informe están completas de todos modos.',
  'adv.rpt.narr.drivers': 'Qué se ha movido',
  'adv.rpt.narr.watch': 'Qué vigilar',
  'adv.rpt.narr.nextStep': 'Siguiente paso: ',
  'adv.rpt.narr.foot': 'El resumen se redacta a partir de las cifras de este informe. Cada importe se comprueba con el informe antes de mostrar el texto.',
  'adv.rpt.sec.changeSince': 'Cambios desde el último informe',
  'adv.rpt.col.lastReport': 'Último informe',
  'adv.rpt.col.now': 'Ahora',
  'adv.rpt.col.change': 'Variación',
  'adv.rpt.note.changeSinceBasis': 'Comparado con el informe guardado el {date}. Esas cifras son una instantánea y no cambian después.',
  'adv.rpt.empty.noPreviousReport': 'Este es el primer informe guardado de este tipo para el año. La próxima vez, esta sección mostrará lo que ha cambiado desde ahora.',
  'adv.rpt.empty.noComparableReport': 'El informe anterior no tiene cifras clave con las que comparar.',
  'adv.rpt.sec.summary': 'Resumen',
  'adv.rpt.sec.events': 'Hechos relevantes',
  'adv.rpt.sec.keyFigures': 'Cifras clave',
  'adv.rpt.sec.budget': 'Resultado frente al presupuesto',
  'adv.rpt.sec.liquidity': 'Liquidez y obligaciones de pago',
  'adv.rpt.sec.forecast': 'Saldo acumulado durante el año',
  'adv.rpt.sec.balance': 'Balance y solidez',
  'adv.rpt.sec.resultTrend': 'Evolución del resultado',
  'adv.rpt.sec.sales': 'Ventas y evolución de clientes',
  'adv.rpt.sec.customerChange': 'Fidelidad de clientes y plazo de pago',
  'adv.rpt.sec.costTrend': 'Evolución de los costes',
  'adv.rpt.sec.suppliers': 'Mayores proveedores',
  'adv.rpt.sec.voucherReview': 'Justificantes por revisar',
  'adv.rpt.sec.receivables': 'Partidas de clientes',
  'adv.rpt.sec.payables': 'Partidas de proveedores',
  'adv.rpt.sec.risk': 'Riesgos e incertidumbre',
  'adv.rpt.sec.actions': 'Acciones recomendadas',
  'adv.rpt.sec.decisions': 'Asuntos a decidir',
  'adv.rpt.sec.dataBasis': 'Base de datos',
  'adv.rpt.sec.bridge': 'Qué ha movido el resultado',
  'adv.rpt.sec.workingCapital': 'Capital circulante y tiempo inmovilizado',
  'adv.rpt.sec.rolling': 'Últimos doce meses',
  'adv.rpt.col.driver': 'Factor',
  'adv.rpt.col.effect': 'Efecto',
  'adv.rpt.col.priority': 'Prioridad',
  'adv.rpt.bridge.opening': 'Resultado {year}',
  'adv.rpt.bridge.closing': 'Resultado {year}',
  'adv.rpt.bridge.revenue': 'Variación de los ingresos',
  'adv.rpt.bridge.finance': 'Variación de las partidas financieras',
  'adv.rpt.bridge.other': 'Otras partidas ({count} líneas)',
  'adv.rpt.bridge.readGuide': 'Léelo de izquierda a derecha: empieza con el resultado del año pasado. El verde aumenta el resultado y el rojo lo reduce. La última barra es el resultado de este año. Los importes de abajo muestran cada contribución.',
  'adv.rpt.bridge.readShort': 'Del año pasado a este año · El verde aumenta el resultado · El rojo lo reduce',
  'adv.rpt.note.bridgeBasis': 'Las líneas con un efecto inferior a {amount} se agrupan. El puente va del resultado de {year} al de este año, y los factores suman la variación total.',
  'adv.rpt.empty.noBridgeBasis': 'Sin cifras contabilizadas de {year} no se puede desglosar la variación por factores.',
  'adv.rpt.empty.noBridgeChange': 'El resultado no ha cambiado respecto a {year}.',
  'adv.rpt.metric.receivableDays': 'Cuentas por cobrar',
  'adv.rpt.metric.payableDays': 'Cuentas por pagar',
  'adv.rpt.metric.capitalGap': 'Tiempo neto inmovilizado',
  'adv.rpt.metric.measuredPaymentDays': 'Plazo de pago real',
  'adv.rpt.metric.netCapitalTied': 'Capital neto inmovilizado',
  'adv.rpt.note.capitalGapPositive': 'Esperas {days} días más para cobrar de lo que tardas en pagar. Es el período en que la actividad debe financiarse con tu propia caja.',
  'adv.rpt.note.capitalGapNegative': 'Pagas más tarde de lo que cobras, así que el crédito de proveedores financia parte de la actividad.',
  'adv.rpt.note.capitalGapUnknown': 'No se puede calcular el tiempo neto inmovilizado porque falta la base de ingresos o de costes.',
  'adv.rpt.note.workingCapitalBasis': 'Los días de cobro y de pago son estimaciones basadas en las partidas abiertas y en {months} meses del ejercicio del informe. El plazo de pago real usa solo las facturas de clientes pagadas, por lo que es un cálculo distinto.',
  'adv.rpt.empty.noWorkingCapital': 'No hay partidas abiertas de clientes ni de proveedores sobre las que medir el tiempo inmovilizado.',
  'adv.rpt.cell.vsPrevious12': 'frente a los 12 anteriores',
  'adv.rpt.note.rollingBasis': 'La ventana son los últimos {months} meses contabilizados, por lo que la comparación cruza el cierre del año y no se ve afectada por la estacionalidad.',
  'adv.rpt.note.noRollingComparison': 'No hay historial suficiente para comparar con los doce meses anteriores.',
  'adv.rpt.empty.noRollingBasis': 'Hay muy poco historial contabilizado para construir una ventana móvil de doce meses.',
  'adv.rpt.certainty.planned': 'Planificado',
  'adv.rpt.summary.profit': 'Tras {months} meses de {year}, se han contabilizado {income} de ingresos y un beneficio de {result}.',
  'adv.rpt.summary.loss': 'Tras {months} meses de {year}, se han contabilizado {income} de ingresos y una pérdida de {result}.',
  'adv.rpt.summary.margin': 'Eso da un margen de beneficio del {margin} %.',
  'adv.rpt.kpi.income': 'Ingresos',
  'adv.rpt.kpi.costs': 'Costes',
  'adv.rpt.kpi.result': 'Resultado',
  'adv.rpt.kpi.margin': 'Margen de beneficio',
  'adv.rpt.kpi.revenue': 'Ventas facturadas',
  'adv.rpt.kpi.invoiceCount': 'Número de facturas',
  'adv.rpt.kpi.avgInvoice': 'Promedio por factura',
  'adv.rpt.kpi.customerCount': 'Número de clientes',
  'adv.rpt.metric.receivables': 'Pendiente de clientes',
  'adv.rpt.metric.payables': 'Adeudado a proveedores',
  'adv.rpt.metric.buffer': 'Colchón de liquidez',
  'adv.rpt.metric.lowestBalance': 'Saldo más bajo del año',
  'adv.rpt.metric.assets': 'Total de activos',
  'adv.rpt.metric.equityAndDebt': 'Total de patrimonio y pasivos',
  'adv.rpt.metric.solidity': 'Ratio de patrimonio',
  'adv.rpt.metric.repeatRate': 'Clientes recurrentes',
  'adv.rpt.metric.avgPaymentDays': 'Plazo medio de pago',
  'adv.rpt.unit.days': '{days} días',
  'adv.rpt.col.line': 'Línea',
  'adv.rpt.col.account': 'Cuenta',
  'adv.rpt.col.budgetToDate': 'Presupuesto a la fecha',
  'adv.rpt.col.actual': 'Contabilizado',
  'adv.rpt.col.variance': 'Desviación',
  'adv.rpt.col.month': 'Mes',
  'adv.rpt.col.in': 'Entradas',
  'adv.rpt.col.out': 'Salidas',
  'adv.rpt.col.balance': 'Saldo',
  'adv.rpt.col.certainty': 'Base',
  'adv.rpt.col.income': 'Ingresos',
  'adv.rpt.col.costs': 'Costes',
  'adv.rpt.col.result': 'Resultado',
  'adv.rpt.col.share': 'Porcentaje',
  'adv.rpt.chart.budgetActual': 'Presupuesto frente a lo contabilizado a la fecha',
  'adv.rpt.chart.monthlyResult': 'Resultado mensual',
  'adv.rpt.chart.incomeCosts': 'Ingresos y costes mensuales',
  'adv.rpt.chart.summaryResult': 'De los ingresos al resultado',
  'adv.rpt.chart.keyFiguresComparison': 'Cifras clave frente al año pasado',
  'adv.rpt.chart.previousPeriod': 'Período anterior',
  'adv.rpt.chart.currentPeriod': 'Período actual',
  'adv.rpt.chart.cumulativeResult': 'Resultado acumulado durante el año',
  'adv.rpt.chart.runningBalance': 'Saldo acumulado y colchón de liquidez',
  'adv.rpt.chart.openItemsDue': 'Partidas abiertas por estado de vencimiento',
  'adv.rpt.chart.workingCapitalGap': 'Capital inmovilizado en partidas abiertas',
  'adv.rpt.chart.balanceBasis': 'Grupos del balance contabilizados',
  'adv.rpt.chart.bookedBalance': 'Saldo contabilizado',
  'adv.rpt.chart.capitalStructure': 'Estructura de capital',
  'adv.rpt.chart.equityShare': 'Patrimonio',
  'adv.rpt.chart.otherFinancing': 'Otra financiación',
  'adv.rpt.chart.profit': 'Beneficio',
  'adv.rpt.chart.loss': 'Pérdida',
  'adv.rpt.col.amount': 'Importe',
  'adv.rpt.col.changeYoy': 'Variación frente al año pasado',
  'adv.rpt.col.status': 'Estado',
  'adv.rpt.row.income': 'Ingresos',
  'adv.rpt.row.costs': 'Costes',
  'adv.rpt.row.notDue': 'Aún no vencido',
  'adv.rpt.row.current': 'Aún no vencido',
  'adv.rpt.row.overdue': 'Vencido',
  'adv.rpt.row.total': 'Total',
  'adv.rpt.cell.vsPreviousYear': 'frente al año pasado',
  'adv.rpt.cell.noBasis': 'Sin comparación',
  'adv.rpt.month.jan': 'Enero',
  'adv.rpt.month.feb': 'Febrero',
  'adv.rpt.month.mar': 'Marzo',
  'adv.rpt.month.apr': 'Abril',
  'adv.rpt.month.may': 'Mayo',
  'adv.rpt.month.jun': 'Junio',
  'adv.rpt.month.jul': 'Julio',
  'adv.rpt.month.aug': 'Agosto',
  'adv.rpt.month.sep': 'Septiembre',
  'adv.rpt.month.oct': 'Octubre',
  'adv.rpt.month.nov': 'Noviembre',
  'adv.rpt.month.dec': 'Diciembre',
  'adv.rpt.certainty.confirmed': 'Contabilizado',
  'adv.rpt.certainty.expected': 'Mes actual',
  'adv.rpt.certainty.uncertain': 'Aún sin contabilizar',
  'adv.rpt.budget.intro': 'Las cifras contabilizadas de {months} meses de {year} se comparan con el presupuesto de esos mismos meses, no con el presupuesto del año completo.',
  'adv.rpt.vouchers.missing': '{count} compras contabilizadas no tienen justificante, con {net} de base y {vat} de IVA deducido.',
  'adv.rpt.action.impact': '{label}: {value}',
  'adv.rpt.priority.high': 'Alta',
  'adv.rpt.priority.medium': 'Media',
  'adv.rpt.priority.low': 'Baja',
  'adv.rpt.severity.critical': 'Crítico',
  'adv.rpt.severity.watch': 'Requiere seguimiento',
  'adv.rpt.severity.info': 'Informativo',
  'adv.rpt.decision.risk': 'Decidir sobre: {name}',
  'adv.rpt.decision.opportunity': 'Considerar: {name}',
  'adv.rpt.decision.freeCapital': 'Decidir cómo usar el capital libre de {amount}.',
  'adv.rpt.note.noPreviousYear': 'No hay cifras contabilizadas de {year}, por lo que no se puede calcular la variación respecto al año pasado.',
  'adv.rpt.note.partialYear': 'El período no está cerrado. Las cifras abarcan {months} meses de {year}.',
  'adv.rpt.note.noMaterialVariance': 'Ninguna línea individual se desvía de forma relevante del presupuesto.',
  'adv.rpt.note.unbudgeted': '{count} cuentas tienen importes contabilizados sin línea de presupuesto. Están incluidas en los totales.',
  'adv.rpt.note.belowBuffer': 'El saldo calculado más bajo es {lowest}, por debajo del objetivo de colchón seleccionado de {buffer}.',
  'adv.rpt.note.aboveBuffer': 'El saldo acumulado se mantiene por encima del colchón de {buffer} durante todo el período.',
  'adv.rpt.note.forecastIsBooked': 'La curva es un saldo acumulado de cifras contabilizadas, no un modelo de previsión. Los meses sin nada contabilizado todavía se mantienen planos.',
  'adv.rpt.note.balanceGrouping': 'El patrimonio y los pasivos se muestran juntos, como los agrupa el balance de comprobación.',
  'adv.rpt.note.balanceInterimBasis': 'Los grupos del balance se muestran tal como están contabilizados en la fecha del informe. Una diferencia entre ambos lados puede incluir el resultado del período y no debe interpretarse como un balance anual cerrado.',
  'adv.rpt.note.noCustomerSplit': 'Las ventas no están desglosadas por cliente en los datos de origen.',
  'adv.rpt.note.concentration': '{name} representa el {pct} % de las ventas facturadas.',
  'adv.rpt.note.customerBasis': 'El plazo de pago se mide en las facturas que realmente se han pagado.',
  'adv.rpt.note.costJump': 'Una o más líneas de costes han subido más del 25 % respecto al año pasado.',
  'adv.rpt.note.topFiveOnly': 'Se muestran los cinco mayores. El resto está en los totales pero no aparece en la lista.',
  'adv.rpt.note.vouchersComplete': 'Todas las compras contabilizadas tienen justificante.',
  'adv.rpt.note.vouchersRequired': 'La ley de contabilidad exige documentación para cada asiento. Los justificantes que faltan deben conseguirse antes de presentar el período.',
  'adv.rpt.note.overdueSales': '{amount} están vencidos por parte de clientes y requieren seguimiento.',
  'adv.rpt.note.overduePurchases': '{amount} están vencidos con proveedores.',
  'adv.rpt.note.noRisks': 'No hay hallazgos de riesgo en las cifras contabilizadas.',
  'adv.rpt.note.noActions': 'Ahora mismo no se recomienda ninguna acción.',
  'adv.rpt.note.notAProtocol': 'Esto es apoyo a la decisión y no sustituye al acta del consejo. Los acuerdos los adopta el consejo.',
  'adv.rpt.empty.noBookkeeping': 'No hay ingresos ni costes contabilizados en {year}. El informe tendrá cifras en cuanto haya justificantes.',
  'adv.rpt.empty.noEvents': 'No se registraron cambios relevantes en el período.',
  'adv.rpt.empty.noBudget': 'No hay presupuesto para {year}. Añade un presupuesto para obtener desviaciones en el informe.',
  'adv.rpt.empty.noLiquidityBasis': 'No hay partidas abiertas de clientes ni de proveedores, ni movimientos contabilizados sobre los que construir el saldo.',
  'adv.rpt.empty.noForecast': 'No hay una base de caja conciliada disponible para la curva de saldo.',
  'adv.rpt.empty.noBalance': 'El balance de comprobación de {year} está vacío.',
  'adv.rpt.empty.noSales': 'No hay ventas facturadas contabilizadas en {year}.',
  'adv.rpt.empty.noCustomerHistory': 'Hay muy poco historial de clientes para medir la recurrencia y el plazo de pago.',
  'adv.rpt.empty.noCosts': 'No hay costes contabilizados en {year}.',
  'adv.rpt.empty.noSupplierSplit': 'Los costes no están desglosados por proveedor en los datos de origen.',
  'adv.rpt.empty.noReceivables': 'No hay partidas pendientes de clientes.',
  'adv.rpt.empty.noPayables': 'No hay partidas pendientes de proveedores.',
  'adv.rpt.empty.noDecisions': 'Ahora mismo ningún asunto requiere una decisión.',
  'adv.rpt.source.result': 'Cuenta de resultados',
  'adv.rpt.source.balance': 'Balance de comprobación',
  'adv.rpt.source.openItems': 'Partidas abiertas de clientes y proveedores',
  'adv.rpt.source.budget': 'Presupuesto',
  'adv.rpt.source.bank': 'Movimientos bancarios',
  'adv.rpt.source.invoices': 'Facturas de clientes',
  'adv.rpt.source.purchases': 'Facturas de proveedores',
  'adv.rpt.source.vouchers': 'Justificantes',
  'adv.rpt.basis.generated': 'Generado el {date}.',
  'adv.rpt.basis.period': 'El período abarca {months} meses de {year}.',
  'adv.rpt.basis.noPreviousYear': 'No hay cifras contabilizadas de {year}: falta la comparación con el año pasado.',
  'adv.rpt.basis.noBudget': 'No hay líneas de presupuesto para {year}.',
  'adv.rpt.basis.noPartySplit': 'El desglose de clientes y proveedores está incompleto. El resumen de clientes muestra importes que pueden rastrearse hasta las ventas facturadas.',
  'adv.rpt.basis.topFive': 'Las listas de clientes y proveedores muestran los cinco mayores.',
  'adv.rpt.basis.bookedOnly': 'Los importes contables proceden del libro mayor. El colchón es un objetivo, no un saldo contabilizado. Los pagos planificados y los indicadores calculados se identifican en el informe.',
  'adv.rpt.period.monthShort': '{month}/{year}',
  'adv.rpt.period.vsPreviousMonth': 'frente al mes anterior',
  'adv.rpt.monthPicker.title': 'Elige un mes para el informe mensual',
  'adv.rpt.monthPicker.intro': 'Elige uno de los últimos 24 meses naturales. El informe usa solo las cifras contabilizadas, el presupuesto y las comparaciones del mes seleccionado.',
  'adv.rpt.monthPicker.separate': 'El informe mensual tiene su propia selección de mes y no se ve afectado por la selección de año o trimestre que usan otros informes.',
  'adv.rpt.monthPicker.continue': 'Elegir mes',
  'adv.rpt.monthPicker.back': 'Volver a las plantillas de informe',
  'adv.rpt.monthPicker.generate': 'Generar informe mensual',
  'adv.rpt.sec.monthlyStatus': 'Estado del mes',
  'adv.rpt.sec.monthlyBudget': 'Mes frente al presupuesto',
  'adv.rpt.sec.monthlyComparison': 'El mismo mes del año pasado',
  'adv.rpt.sec.monthlyTrend': 'Evolución de los últimos 12 meses',
  'adv.rpt.sec.monthlyInsights': 'Valoración mensual y próximos pasos',
  'adv.rpt.empty.noMonthlyBudget': 'No hay presupuesto para el mes seleccionado.',
  'adv.rpt.empty.noMonthlyComparison': 'No hay cifras contabilizadas del mismo mes del año pasado.',
  'adv.rpt.empty.noMonthlyTrend': 'No hay cifras mensuales contabilizadas en la ventana de doce meses.',
  'adv.rpt.col.budget': 'Presupuesto',
  'adv.rpt.col.variancePct': 'Desviación %',
  'adv.rpt.row.result': 'Resultado',
  'adv.rpt.chart.monthBudgetActual': 'Presupuesto y datos reales del mes',
  'adv.rpt.chart.sameMonthComparison': 'Mes seleccionado frente al mismo mes del año pasado',
  'adv.rpt.metric.averageMonthlyResult': 'Resultado mensual medio',
  'adv.rpt.metric.bestMonthlyResult': 'Mejor mes',
  'adv.rpt.metric.weakestMonthlyResult': 'Peor mes',
  'adv.rpt.monthly.statusProfit': 'El mes terminó con un beneficio de {result} y un margen de resultado del {margin}%.',
  'adv.rpt.monthly.statusLoss': 'El mes terminó con una pérdida de {result} y un margen de resultado del {margin}%.',
  'adv.rpt.monthly.budgetAbove': 'El resultado es {amount} mejor que el presupuesto del mes.',
  'adv.rpt.monthly.budgetBelow': 'El resultado es {amount} peor que el presupuesto del mes.',
  'adv.rpt.monthly.marginChange': 'El margen de resultado ha cambiado {change} puntos porcentuales respecto al mismo mes del año pasado.',
  'adv.rpt.monthly.trendBasis': 'La evolución muestra hasta 12 meses naturales contabilizados hasta el mes seleccionado.',
  'adv.rpt.monthly.insightLossTitle': 'Resultado mensual negativo',
  'adv.rpt.monthly.insightLossBody': 'Los costes superaron a los ingresos en {amount} en el mes seleccionado.',
  'adv.rpt.monthly.insightProfitTitle': 'Resultado mensual positivo',
  'adv.rpt.monthly.insightProfitBody': 'El mes generó un beneficio de {amount}. Analiza qué factores de ingresos y costes conviene repetir.',
  'adv.rpt.monthly.insightIncomeDownTitle': 'Ingresos inferiores a los del año pasado',
  'adv.rpt.monthly.insightIncomeDownBody': 'Los ingresos son un {change}% inferiores a los del mismo mes del año pasado.',
  'adv.rpt.monthly.insightCostsTitle': 'Costes por encima del presupuesto',
  'adv.rpt.monthly.insightCostsBody': 'Los costes están {amount} por encima del presupuesto del mes.',
  'adv.rpt.monthly.insightBudgetTitle': 'Resultado por debajo del presupuesto',
  'adv.rpt.monthly.insightBudgetBody': 'El resultado es {amount} peor que el presupuesto del mes.',
  'adv.rpt.monthly.stepReviewDrivers': 'Revisa los asientos que explican el resultado mensual y aclara qué efectos son duraderos.',
  'adv.rpt.monthly.stepRevenue': 'Haz seguimiento de la caída de ingresos frente al mismo mes del año pasado.',
  'adv.rpt.monthly.stepCosts': 'Identifica los costes que superan el presupuesto mensual.',
  'adv.rpt.monthly.stepBudget': 'Actualiza las acciones necesarias para cerrar la desviación del resultado frente al presupuesto mensual.',
  'adv.rpt.monthly.stepContinue': 'Mantén los factores que explican el resultado mensual positivo y vigila la evolución el próximo mes.',
});
